
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import '../theme/index.css'
import Vuex from 'vuex'
import store from '@/store/index'
import wysiwyg from 'vue-wysiwyg'
import VueJWT from 'vuejs-jwt'
import vClickOutside from 'v-click-outside'
import SharedButtons from '@/components/Shared/SharedButtons'
import Modal from './components/Modal/Modal'
import i18n from './i18n/setup/i18n-setup'
import { getTranslations } from './i18n/setup/i18n-setup'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faClone, faDonate, faUser, faUsers, faStickyNote, faStream, faPaperclip } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
 
export const ImageUrl = 'https://regagen-pc-api.blackdot.co.me/api';
export const API = 'https://regagen-pc-api.blackdot.co.me/api';

getTranslations()

const token = localStorage.getItem('authToken')

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.use(wysiwyg, { image: {
                      uploadURL: `https://regagen-pc-api.blackdot.co.me/api/images`,
                      dropzoneOptions: {
                        headers: { Authorization: 'Bearer '+token }
                      }
                    }, 
});
Vue.use(VueJWT, {});
Vue.use(vClickOutside)
library.add(faClone, faDonate, faUser, faUsers, faStickyNote, faStream, faPaperclip)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('shared-buttons', SharedButtons)
Vue.component('modal', Modal);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js